/**
 * **Nach jedem Speichern kommt das Namensverzeichnis neu** (7.2 Abschnitt 20,
 * Nachtrag 2026-10-14, R1736).
 *
 * Der Befund der Probe vom 2026-10-14: Direkt nach dem Anlegen eines
 * Statistikkontos stand in der Kapitalflussrechnung *„KTO-000031-05“* statt
 * seines Namens — das Verzeichnis kam nur beim Start. Jetzt meldet die
 * Schnittstelle jedes erfolgreiche Speichern (`api.ts`), und hier wird daraus
 * höchstens ein Abruf je Sekunde: Wer fünf Felder hintereinander speichert,
 * löst einen aus und nicht fünf.
 */

/** Das Ereignis, mit dem die Schnittstelle ein erfolgreiches Speichern meldet. */
export const GESPEICHERT = 'coko.gespeichert'

/** Meldet ein erfolgreiches Speichern — aus der einen Stelle, über die jeder Schreibweg läuft. */
export function meldeGespeichert(): void {
  window.dispatchEvent(new CustomEvent(GESPEICHERT))
}

/**
 * Ruft `laden` eine Sekunde nach dem letzten Speichern — zusammengefasst, wie
 * oft auch gespeichert wurde. Gibt zurück, womit die Beobachtung endet.
 */
export function beobachteSpeichern(laden: () => void, warte = 1000): () => void {
  let zeitgeber: ReturnType<typeof setTimeout> | null = null
  const beiSpeichern = () => {
    if (zeitgeber !== null) {
      clearTimeout(zeitgeber)
    }
    zeitgeber = setTimeout(() => {
      zeitgeber = null
      laden()
    }, warte)
  }

  window.addEventListener(GESPEICHERT, beiSpeichern)
  return () => {
    window.removeEventListener(GESPEICHERT, beiSpeichern)
    if (zeitgeber !== null) {
      clearTimeout(zeitgeber)
    }
  }
}
